
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event/[eventId]/breakout-rooms/[roomId]",
      function () {
        return require("private-next-pages/event/[eventId]/breakout-rooms/[roomId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event/[eventId]/breakout-rooms/[roomId]"])
      });
    }
  